import { events } from "./events/index"

const GeneralSection = {
  events
};

export { GeneralSection };
